import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { useNavigate } from 'react-router-dom';
import Pagination from '../components/Pagination';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import { Loader } from '../components/ModalsCommonFunctions';

const SyllabusMaster = () => {
    const authorizedAxios = generateAxiosInstance()
    const initialFormState = {
        boardMasterId: '',
        streamOrMediumMasterId: '',
        syllabusTypeMasterId: '',
        gradeMasterId: '',
        subjectMasterId: '',
        publicationMasterId: '',
        syllabusStructureName: ['']
    }
    const [formData, setFormData] = useState([])
    const [syllabusData, setSyllabusData] = useState(initialFormState)
    const [syllabusList, setSyllabusList] = useState([])
    const [editId, setEditId] = useState(null)
    const [subjectEdit, setSubjectEdit] = useState({
        subjectMasterId: []
    })
    const [subjectEditError, setSubjectEditError] = useState("");

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [refresh, setRefresh] = useState(true);
    const [addNewSyllabus, setAddNewSyllabus] = useState(false);

    const [syllabusNameSort, setSyllabusNameSort] = useState(null);
    const [boardSort, setBoardSort] = useState(null);
    const [mediumSort, setMediumSort] = useState(null);
    const [syllabusTypeSort, setSyllabusTypeSort] = useState(null);
    const [classSort, setClassSort] = useState(null);
    const [subjectSort, setSubjectSort] = useState(null);
    const [publicationSort, setPublicationSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["syllabusStructureName", "boardMasterDetails.boardName", "streamOrMediumMasterDetails.streamName", "syllabusTypeMasterDetails.syllabusTypeName", "gradeMasterDetails.gradeName", "syllabusStructureDetails.subjectMasterDetails.subjectName", "publicationMasterDetails.publicationName"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        const apiUrl = `/get-data-for-syllabus-structure-master`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setFormData(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            setRefresh(!refresh);
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const getApiUrl = () => {
        let apiUrl = '/get-syllabus-structure-master-list?';

        if (syllabusData.boardMasterId) {
            apiUrl += `boardId=${syllabusData.boardMasterId}&`;
        }
        if (syllabusData.streamOrMediumMasterId) {
            apiUrl += `streamId=${syllabusData.streamOrMediumMasterId}&`;
        }
        if (syllabusData.syllabusTypeMasterId) {
            apiUrl += `syllabusTypeId=${syllabusData.syllabusTypeMasterId}&`;
        }
        if (syllabusData.gradeMasterId) {
            apiUrl += `gradeId=${syllabusData.gradeMasterId}&`;
        }
        if (syllabusData.subjectMasterId) {
            apiUrl += `subjectId=${syllabusData.subjectMasterId}&`;
        }
        if (syllabusData.publicationMasterId) {
            apiUrl += `publicationId=${syllabusData.publicationMasterId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    const handleSearch = async () => {
        if (syllabusData.boardMasterId !== '') {
            setSyllabusList(await searchArray("A", getApiUrl(), searchKeys, searchValue.trim()))
        }
    }

    useEffect(() => {
        if (syllabusData.boardMasterId !== '') {
            authorizedAxios && authorizedAxios.get(getApiUrl())
                .then(response => {
                    setSyllabusList(response.data.result);
                })
                .catch(error => {
                    setSyllabusList(error?.response?.data.result);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    }, [syllabusData, refresh]);

    const getSyllabusList = () => {
        if (syllabusData.boardMasterId !== '') {
            authorizedAxios && authorizedAxios.get(getApiUrl())
                .then(response => {
                    setSyllabusList(response.data.result);
                    setAddNewSyllabus(!addNewSyllabus);
                })
                .catch(error => {
                    setSyllabusList(error?.response?.data.result);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(syllabusList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId, addNewSyllabus])

    useEffect(() => {
        setTotalPages(Math.ceil(syllabusList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > syllabusList.length) {
            endIndex = syllabusList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(syllabusList.slice(startIndex, endIndex));
    }, [syllabusList, currPage, itemsPerPage]);

    const handleInputChange = (e, index) => {
        setSyllabusData((prevData) => {
            if (e.target.name === 'syllabusStructureName') {
                // Update the value at the specified index
                const updatedSyllabusStructureName = [...prevData.syllabusStructureName];
                updatedSyllabusStructureName[index] = e.target.value;
                return {
                    ...prevData,
                    syllabusStructureName: updatedSyllabusStructureName,
                }
            } else {
                return {
                    ...prevData,
                    [e.target.name]: e.target.value,
                }
            }
        })
    }

    const handleSubjectChange = (selectedOptions) => {
        const selectedIds = selectedOptions.map((option) => option.value.toString());
        setSyllabusData((prevData) => {
            return {
                ...prevData,
                subjectMasterId: selectedIds,
            }
        })
    }

    function arraysHaveCommonValues(array1, array2) {
        let commonValuesFound = false;
        for (const value of array1) {
            if (array2.includes(value)) {
                commonValuesFound = true;
                break;
            }
        }
        return commonValuesFound;
    }

    useEffect(() => {
        if (subjectEdit.subjectMasterId.length !== 0) {
            setSubjectEditError("");
        }
    }, [subjectEdit])

    const handleChangeEdit = (selectedOptions) => {
        const selectedIds = selectedOptions.map((option) => option.value.toString());

        !arraysHaveCommonValues(selectedIds, syllabusData.subjectMasterId) && setSubjectEdit((prevData) => {
            return {
                ...prevData,
                subjectMasterId: selectedIds,
            }
        })
    }

    const handleAddSyllabus = () => {
        setSyllabusData((prevData) => ({
            ...prevData,
            syllabusStructureName: [...prevData.syllabusStructureName, ''],
        }));
    };


    const handleRemoveSyllabus = (index) => {
        setSyllabusData((prevData) => {
            const updatedSyllabusStructureName = [...prevData.syllabusStructureName];
            // Remove the element at the specified index
            updatedSyllabusStructureName.splice(index, 1);
            return {
                ...prevData,
                syllabusStructureName: updatedSyllabusStructureName,
            }
        });
    };

    //error
    const initialErrorState = {

    }

    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(syllabusData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(syllabusData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [syllabusData])

    const addSyllabusType = () => {
        const apiUrl = `/add-syllabus-structure-master`;
        if (validateForm()) {
            setLoading(true);
            authorizedAxios && authorizedAxios.post(apiUrl, syllabusData)
                .then(response => {
                    getSyllabusList();
                    setSyllabusData((prevData) => {
                        return {
                            ...prevData,
                            syllabusStructureName: [''],
                        }
                    })

                    setSaveId(response.data.result[0].id);
                    setSyllabusNameSort(null);
                    setBoardSort(null);
                    setMediumSort(null);
                    setSyllabusTypeSort(null);
                    setClassSort(null);
                    setSubjectSort(null);
                    setPublicationSort(null);
                    setSearchValue(null);

                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            for (const [key, value] of Object.entries(syllabusData)) {
                if (value == '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const deleteSyllabus = (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            setLoading(true);
            const apiUrl = `/delete-syllabus-structure-master?id=${id}`;
            authorizedAxios && authorizedAxios.delete(apiUrl)
                .then(response => {
                    const page = deleteItem(currPage, itemsPerPage, syllabusList.length);
                    setRefresh(!refresh);
                    setCurrPage(page);

                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire({
                        title: errorMsg,
                        text: 'Do you want to delete forcefully?',
                        showCancelButton: true,
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'No',
                        showLoaderOnConfirm: true,
                        preConfirm: async () => {
                            return Swal.fire({
                                html: `
                                    <div>
                                        <p>Enter Administrative Password:</p>
                                        <input type="password" id="swal-input" class="swal2-input" placeholder="Password">
                                    </div>
                                `,
                                showCancelButton: true,
                                confirmButtonText: 'Submit',
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    const inputValue = document.getElementById('swal-input').value;
                                    const confirmAPIurl = `/force-delete-syllabus-structure?id=${id}&password=${inputValue}`;
                                    authorizedAxios && authorizedAxios.delete(confirmAPIurl)
                                        .then(response => {
                                            // setSyllabusList((prevList) => [...prevList].filter((list) => list.id !== id))
                                            const page = deleteItem(currPage, itemsPerPage, syllabusList.length);
                                            setRefresh(!refresh);
                                            setCurrPage(page);

                                            Swal.fire(
                                                { text: response.data.message }
                                            );
                                        })
                                        .catch(error => {
                                            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                                            Swal.fire(
                                                { text: errorMsg }
                                            );
                                        });
                                }
                            });
                        }
                    }).then((result) => {
                        console.log('Confirmation result:', result);
                    }).catch((error) => {
                        console.error('Error:', error);
                    });
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        }
    }

    const updateSyllabus = () => {
        const apiUrl = `/edit-syllabus-structure-master?id=${editId}`;
        if (subjectEdit.subjectMasterId.length !== 0) {
            setLoading(true);
            authorizedAxios && authorizedAxios.put(apiUrl, subjectEdit)
                .then(response => {
                    setEditId(null);
                    setSyllabusList(response.data.result)
                    setSyllabusData(initialFormState);
                    setSubjectEditError("");
                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            setSubjectEditError("This field is required.");
        }
    }

    const SubList = formData?.subjectData?.map((sub) => {
        return {
            value: sub.id,
            label: sub.subjectName,
        }
    }) || [];

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            background: syllabusData.subjectMasterId.includes(state.value.toString()) ? 'lightpink' : 'white',
        }),
    }

    const handleReset = () => {
        setSyllabusList([]);
        setEditId(null);
        setSyllabusData(initialFormState);
        setSubjectEditError("");
        setDisplayedData([]);
        setSyllabusNameSort(null);
        setBoardSort(null);
        setMediumSort(null);
        setSyllabusTypeSort(null);
        setClassSort(null);
        setSubjectSort(null);
        setPublicationSort(null);
        setError(initialErrorState);
    }

    useEffect(() => {
        if (syllabusNameSort == true || syllabusNameSort == false) {
            setBoardSort(null);
            setMediumSort(null);
            setSyllabusTypeSort(null);
            setClassSort(null);
            setSubjectSort(null);
            setPublicationSort(null);
        }
    }, [syllabusNameSort])

    useEffect(() => {
        if (boardSort == true || boardSort == false) {
            setSyllabusNameSort(null);
            setMediumSort(null);
            setSyllabusTypeSort(null);
            setClassSort(null);
            setSubjectSort(null);
            setPublicationSort(null);
        }
    }, [boardSort])

    useEffect(() => {
        if (mediumSort == true || mediumSort == false) {
            setSyllabusNameSort(null);
            setBoardSort(null);
            setSyllabusTypeSort(null);
            setClassSort(null);
            setSubjectSort(null);
            setPublicationSort(null);
        }
    }, [mediumSort])

    useEffect(() => {
        if (syllabusTypeSort == true || syllabusTypeSort == false) {
            setSyllabusNameSort(null);
            setBoardSort(null);
            setMediumSort(null);
            setClassSort(null);
            setSubjectSort(null);
            setPublicationSort(null);
        }
    }, [syllabusTypeSort])

    useEffect(() => {
        if (classSort == true || classSort == false) {
            setSyllabusNameSort(null);
            setBoardSort(null);
            setMediumSort(null);
            setSyllabusTypeSort(null);
            setSubjectSort(null);
            setPublicationSort(null);
        }
    }, [classSort])

    useEffect(() => {
        if (subjectSort == true || subjectSort == false) {
            setSyllabusNameSort(null);
            setBoardSort(null);
            setMediumSort(null);
            setSyllabusTypeSort(null);
            setClassSort(null);
            setPublicationSort(null);
        }
    }, [subjectSort])

    useEffect(() => {
        if (publicationSort == true || publicationSort == false) {
            setSyllabusNameSort(null);
            setBoardSort(null);
            setMediumSort(null);
            setSyllabusTypeSort(null);
            setClassSort(null);
            setSubjectSort(null);
        }
    }, [publicationSort])


    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Syllabus Structure </span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-sitemap"></i> Syllabus Structure </b></h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Board :</label>
                                                    <select class="form-select" disabled={editId} aria-label="Default select example" name='boardMasterId' onChange={handleInputChange} value={syllabusData.boardMasterId}>
                                                        <option selected value={''} disabled>Select Board</option>
                                                        {
                                                            formData?.boardData?.map((board) => {
                                                                return <option value={board.id}>{board.boardName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.boardMasterId && <p style={{ color: 'red' }}>{error.boardMasterId}</p>}
                                                </div>
                                                <div className="col-md-4">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Medium :</label>
                                                    <select class="form-select" disabled={editId} aria-label="Default select example" name='streamOrMediumMasterId' onChange={handleInputChange} value={syllabusData.streamOrMediumMasterId}>
                                                        <option selected value={''} disabled>Select Medium</option>
                                                        {
                                                            formData?.streamOrMediumData?.map((stream) => {
                                                                return <option value={stream.id}>{stream.streamName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.streamOrMediumMasterId && <p style={{ color: 'red' }}>{error.streamOrMediumMasterId}</p>}
                                                </div>
                                                <div className="col-md-4">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Syllabus Type :</label>
                                                    <select class="form-select" disabled={editId} aria-label="Default select example" name='syllabusTypeMasterId' onChange={handleInputChange} value={syllabusData.syllabusTypeMasterId}>
                                                        <option selected value={''} disabled>Select Type</option>
                                                        {
                                                            formData?.syllabusTypeData?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.syllabusTypeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.syllabusTypeMasterId && <p style={{ color: 'red' }}>{error.syllabusTypeMasterId}</p>}

                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <select class="form-select" disabled={editId} aria-label="Default select example" name='gradeMasterId' onChange={handleInputChange} value={syllabusData.gradeMasterId}>
                                                        <option selected value={''} disabled>Select Class</option>
                                                        {
                                                            formData?.gradeData?.map((grade) => {
                                                                return <option value={grade.id}>{grade.gradeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.gradeMasterId && <p style={{ color: 'red' }}>{error.gradeMasterId}</p>}
                                                </div>
                                                {editId ?
                                                    <div className="col-md-4">
                                                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject Edit : {syllabusData.subjectMasterId.length} selected</label>
                                                        <Select
                                                            value={SubList.filter(option =>
                                                                subjectEdit.subjectMasterId && subjectEdit.subjectMasterId.includes(option.value.toString())
                                                            )}
                                                            isMulti
                                                            name="subjectMasterId"
                                                            options={SubList}
                                                            className="basic-multi-select"
                                                            classNamePrefix="Select Board"
                                                            onChange={handleChangeEdit}
                                                            styles={customStyles}
                                                        />
                                                        {error.subjectMasterId && <p style={{ color: 'red' }}>{error.subjectMasterId}</p>}

                                                        {editId && subjectEditError.length !== 0 && <p style={{ color: 'red' }}>{subjectEditError}</p>}
                                                    </div>

                                                    : <div className="col-md-4">
                                                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                        <Select
                                                            value={SubList.filter(option =>
                                                                syllabusData.subjectMasterId && syllabusData.subjectMasterId.includes(option.value.toString())
                                                            )}
                                                            isMulti
                                                            name="subjectMasterId"
                                                            options={SubList}
                                                            className="basic-multi-select"
                                                            classNamePrefix="Select Board"
                                                            onChange={handleSubjectChange}
                                                        />
                                                        {error.subjectMasterId && <p style={{ color: 'red' }}>{error.subjectMasterId}</p>}
                                                    </div>}
                                                <div className="col-md-4">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Publication :</label>
                                                    <select class="form-select" disabled={editId} aria-label="Default select example" name='publicationMasterId' onChange={handleInputChange} value={syllabusData.publicationMasterId}>
                                                        <option selected value={''} disabled>Select Publication</option>
                                                        {
                                                            formData?.publicationData?.map((publication) => {
                                                                return <option value={publication.id}>{publication.publicationName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.publicationMasterId && <p style={{ color: 'red' }}>{error.publicationMasterId}</p>}
                                                </div>
                                            </div>
                                            <div className="row">
                                                {syllabusData.syllabusStructureName.map((syllabus, index) => (
                                                    <>
                                                        <div className="col-md-11">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Syllabus Name :</label>
                                                            <input type="text" disabled={editId} className="form-control" id={`syllabusName${index}`} name='syllabusStructureName' onChange={(e) => handleInputChange(e, index)} value={syllabus} />
                                                            {error.syllabusStructureName && <p style={{ color: 'red' }}>{error.syllabusStructureName}</p>}
                                                        </div>
                                                        {syllabusData?.syllabusStructureName?.length > 1 && (
                                                            <div className="col-md-1 mt-4 mb-1" style={{ textAlign: 'right' }}>
                                                                <button className="btn btn-primary" type="button" style={{ marginTop: '14px' }} onClick={() => handleRemoveSyllabus(index)} ><i className="material-icons" style={{ fontSize: '20px' }}>delete</i></button>
                                                            </div>
                                                        )}
                                                    </>
                                                ))}
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 d-flex justify-content-center button-container">
                                                    {!editId && <button className="btn btn-primary" type="button" onClick={addSyllabusType}>Save</button>
                                                    }
                                                    <button className="btn btn-danger delete_icon delete_icon" type="button" onClick={handleReset}>Reset</button>
                                                    {
                                                        editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateSyllabus} disabled={!editId}>Update</button>)
                                                    }
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table custom_table_width ">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Syllabus Name
                                                                            <SortIcon sortState={syllabusNameSort} setSortState={setSyllabusNameSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"syllabusStructureName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Board
                                                                            <SortIcon sortState={boardSort} setSortState={setBoardSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"boardMasterDetails.boardName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Medium
                                                                            <SortIcon sortState={mediumSort} setSortState={setMediumSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"streamOrMediumMasterDetails.streamName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Syllabus Type
                                                                            <SortIcon sortState={syllabusTypeSort} setSortState={setSyllabusTypeSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"syllabusTypeMasterDetails.syllabusTypeName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Class
                                                                            <SortIcon sortState={classSort} setSortState={setClassSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"gradeMasterDetails.gradeName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Subject
                                                                            <SortIcon sortState={classSort} setSortState={setClassSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"syllabusStructureDetails.subjectMasterDetails.subjectName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Publication
                                                                            <SortIcon sortState={publicationSort} setSortState={setPublicationSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"publicationMasterDetails.publicationName"} />
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData.map((syllabus, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{syllabus.syllabusStructureName}</td>
                                                                                        <td>{syllabus.boardMasterDetails?.boardName}</td>
                                                                                        <td>{syllabus.streamOrMediumMasterDetails?.streamName}</td>
                                                                                        <td>{syllabus.syllabusTypeMasterDetails?.syllabusTypeName}</td>
                                                                                        <td>{syllabus.gradeMasterDetails?.gradeName}</td>
                                                                                        <td>{syllabus.syllabusStructureDetails?.map((i) => `${i.subjectMasterDetails.subjectName}, `)}</td>
                                                                                        {/* <td>{syllabus.subjectStructureSubjectMappingDetails.map((i)=>(<div>{i.subjectMasterDetails.subjectName}</div>))}</td> */}
                                                                                        <td>{syllabus.publicationMasterDetails?.publicationName}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => {
                                                                                                setSyllabusData({
                                                                                                    boardMasterId: syllabus.boardMasterDetails?.id,
                                                                                                    streamOrMediumMasterId: syllabus.streamOrMediumMasterDetails?.id,
                                                                                                    syllabusTypeMasterId: syllabus.syllabusTypeMasterDetails?.id,
                                                                                                    gradeMasterId: syllabus.gradeMasterDetails?.id,
                                                                                                    subjectMasterId: syllabus.syllabusStructureDetails.map((i) => i.subjectMasterDetails.id.toString()),
                                                                                                    publicationMasterId: syllabus.publicationMasterDetails?.id,
                                                                                                    syllabusStructureName: [syllabus.syllabusStructureName]
                                                                                                });

                                                                                                setEditId(syllabus.id);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" disabled={editId === syllabus.id} onClick={() => deleteSyllabus(syllabus.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center', padding: "50px" }}>No Syllabus Structure Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>

                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={syllabusList.length} />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SyllabusMaster;